import * as React from 'react';
import { connect } from 'react-redux';
import ImagePicker from 'src/components/utils/ImagePicker/ImagePicker';
import { IconPaths } from 'src/icons';
import { ApplicationState } from 'src/store';
import { createSection } from 'src/store/sections/actions';
import { Section } from 'src/store/sections/types';

interface Props {
  createSection: typeof createSection;
}

interface State {
  title: string;
  file?: File;
}

const initialState = {
  title: '',
  file: undefined
};

class CreateNewUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = initialState;
  }

  render() {
    const cols: any = [
      {
        id: 'title',
        bez: 'Titel'
      },
      {
        id: 'image',
        bez: 'Bild'
      }
    ];
    return (
      <div className="container">
        <div className="col-lg-6 centered">
          <h2 style={{ textAlign: 'left' }}>Themenbereich erstellen</h2>
          <form onSubmit={this.onSave}>
            <table>
              <thead>
                <tr>
                  <th />
                  {cols.map((col: { id: string; type: string; bez: string }, index: number) => {
                    return <th key={index}>{col.bez}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <React.Fragment>
                    <td>
                      <img
                        onClick={this.onSave}
                        src={IconPaths['save-icon']}
                        className="pointer"
                        title="Speichern"
                        height="20px"
                        width="auto"
                      />
                    </td>
                    <td>
                      <input type="text" value={this.state.title} onChange={this.onChange} />
                    </td>
                    <td>
                      <div
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {this.state.file && (
                          <img
                            src={URL.createObjectURL(this.state.file)}
                            style={{
                              opacity: 0.3,
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover',
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              zIndex: -1
                            }}
                          />
                        )}
                        <div style={{ marginTop: '-23px' }}>
                          <ImagePicker onChange={this.onImageChange} />
                        </div>
                      </div>
                    </td>
                  </React.Fragment>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>
    );
  }

  onSave = () => {
    if (this.state.title.length <= 0) {
      return;
    }
    const section: Section = {
      id: -1,
      order_nr: 0,
      title: this.state.title
    };
    this.props.createSection(
      section,
      () => {
        this.setState({ ...initialState });
      },
      this.state.file
    );
  };

  onImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      this.setState({ file });
    }
  };

  onChange = (e: any) => {
    const text = e.target.value;
    this.setState({ title: text });
  };
}

const mapStateToProps = ({ sections }: ApplicationState) => ({
  loading: sections.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  createSection: (section: Section, successCB: () => any, file?: File) =>
    dispatch(createSection(section, successCB, file))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateNewUser);



// WEBPACK FOOTER //
// ./src/pages/Management/SectionManagement/CreateSection/CreateSection.tsx